import Identity from './sdk/identity';

export default Identity;
